export default __webpack_public_path__ + "static/media/DJ Tropix.8fcd87fa.png";